$(function(){
    
    const image = $('figure.resizable img');
    const imageWidth = image.width();
    const imageHeight = image.height();

	const targetNode = document.getElementById('resizable');
	
	const watchConfig = {
        attributes: true,
        attributeFilter: ["style"]
	};
	
	const mutationsCallback = function(mutations) {
		for(let mutation of mutations) {
			if (mutation.type === 'attributes') { //changes in style attribute
                updateDimensionData();
			}
		}
	};
	
	const observer = new MutationObserver(mutationsCallback);
	observer.observe(targetNode, watchConfig);

    function updateDimensionData(){

        const frameWidth = $('figure').width(),
            frameHeight = $('figure').height();
    
        //if frame AR is less than image AR, then set height to make the height 100% of the video container and then overflow width
        if( frameWidth/frameHeight < 4550/3640 ){
            image.css({
                'max-width': 'none',
                'max-height': '100%'
            });
        }else{
            image.css({
                'max-width': '100%',
                'max-height': 'none'
            });
        }
    
        //update frame dimensions table
        $('.frame-dimensions .width .value').text(frameWidth + 'px');
        $('.frame-dimensions .height .value').text(frameHeight + 'px');
    
        $('.frame-dimensions .AR .w').text(reduce(frameWidth, frameHeight)[0]);
        $('.frame-dimensions .AR .h').text(reduce(frameWidth, frameHeight)[1]);
    }
});

//reduce aspect ratio
function reduce(numerator,denominator){
    var gcd = function gcd(a,b){
      return b ? gcd(b, a%b) : a;
    };
    gcd = gcd(numerator,denominator);
    return [numerator/gcd, denominator/gcd];
  }